namespace $.$$ {
	const { vh } = $mol_style_unit

	$mol_style_define( $eve_app_page_components_flex, {

	} )
}
